import { EnumDescriptions } from '@/app/shared/utils';
import { i18n } from '@/plugins';

export enum ClientAccountRefund {
  Holder = 1,
  Payer = 2,
}
EnumDescriptions.setDescriptions(ClientAccountRefund, [
  i18n.t('enums.holder'),
  i18n.t('enums.payer'),
]);
